const state = () => ({
	data: {
    currentSelection: 'Login'
	},
})

const mutations = {
	authControllerCommit(state, data) {
		state.data = data
	},
}

// actions
const actions = {
	authControllerCommit(context, user) {
		context.commit('authControllerCommit', user)
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
}
